import type { ActivityNotice } from '../contracts/types'

export const NOTICES_CONTROLLED_ACCESS: ActivityNotice[] = [
  {
    id: 'notice-controlled-access',
    title: 'Controlled access',
    body: 'Service access is managed through Request Access and Book Demo. App account flows remain in planning.',
    tone: 'info',
  },
  {
    id: 'notice-no-sign-in',
    title: 'Account pathways',
    body: 'Sign In and Create Account are not offered on this preview shell.',
    tone: 'neutral',
  },
  {
    id: 'notice-guided-studio',
    title: 'Guided Studio',
    body: 'You can plan and review creative structure through Guided Studio when your access profile allows.',
    tone: 'neutral',
  },
]

export const NOTICES_VISITOR: ActivityNotice[] = [
  {
    id: 'notice-visitor',
    title: 'Visitor preview',
    body: 'Project progress and tools are shown as examples. Request Access to begin a real creator pathway.',
    tone: 'caution',
  },
  ...NOTICES_CONTROLLED_ACCESS,
]
